import gql from 'graphql-tag';

export const MEDICINES_PROCEDURES_QUERY = gql`
  query MedicinesProcedures {
    medicines {
      id
      label
      groupName
    }
    procedures {
      id
      label
    }
  }
`;

export const MEDICINES_QUERY = gql`
  query medicines {
    medicines {
      id
      label
      groupName
    }
  }
`;

export const PROCEDURES_QUERY = gql`
  query procedures {
    procedures {
      id
      label
    }
  }
`;

export const ADD_PROCEDURE_MUTATION = gql`
  mutation addProcedure($label: String!) {
    addProcedure(label: $label) {
      id
    }
  }
`;

export const DELETE_PROCEDURE_MUTATION = gql`
  mutation deleteProcedure($id: String!) {
    deleteProcedure(id: $id) {
      id
    }
  }
`;

export const UPDATE_PROCEDURE_MUTATION = gql`
  mutation updateProcedure($payload: UpdateProcedureInput!) {
    updateProcedure(payload: $payload) {
      id
    }
  }
`;

export const DELETE_MEDICINE_MUTATION = gql`
  mutation deleteMedicine($id: String!) {
    deleteMedicine(id: $id) {
      id
    }
  }
`;

export const ADD_MEDICINE_MUTATION = gql`
  mutation addMedicine($label: String!, $groupName: String) {
    addMedicine(label: $label, groupName: $groupName) {
      id
    }
  }
`;

export const UPDATE_MEDICINE_MUTATION = gql`
  mutation updateMedicine($payload: UpdateMedicineInput!) {
    updateMedicine(payload: $payload) {
      id
    }
  }
`;
